import React from 'react';
import { Chip } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { baseChipSx, baseLabelSx } from './chipStyles';

export default function TextOnlyChip({
  label,
  color = 'default',
  onClick,
  sx = {},
  disabled = false,
  selected = false,
}) {
  const theme = useTheme();
  const paletteColor = theme.palette[color]?.main || theme.palette.primary.main;
  return (
    <Chip
      label={label}
      color={color}
      variant="outlined"
      clickable={!!onClick && !disabled}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation();
        if (onClick && !disabled) onClick(e);
      }}
      sx={{
        ...baseChipSx,
        '& .MuiChip-label': {
          ...baseLabelSx,
        },
        ...(selected && {
          backgroundColor: alpha(paletteColor, 0.15),
          '&:hover': {
            backgroundColor: alpha(paletteColor, 0.25),
          },
        }),
        ...sx,
      }}
    />
  );
}
